import { careClientVisitorInitRes, careOrderBabyInitRes, journeyCachePutRes, optionGetRes, paramVerifyRes, profileGetRes, profileUpdateRes, timeSlotFeeCalculateRes, } from './mockData';
const defaultResponse = {
    '/api/careClientVisitor/init': careClientVisitorInitRes.success,
    '/api/client/profile/get': profileGetRes.success.default,
    '/api/client/profile/update': profileUpdateRes.success,
    '/api/client/option/get': optionGetRes.success,
    '/api/client/journey/cache/put': journeyCachePutRes.success,
    '/api/v6/client/order/param/verify': paramVerifyRes.success,
    '/api/client/careOrderBaby/init': careOrderBabyInitRes.success,
    '/api/client/order/timeSlot/fee/calculate': timeSlotFeeCalculateRes.success.allDay,
};
const mockScenarios = {
    CARE_ORDER_BABY_INIT_SUCCESS: {
        description: 'successfully init careOrderBaby',
        ...defaultResponse,
    },
    CARE_CLIENT_VISITOR_INIT_ERROR: {
        description: 'careClientVisitor init failed',
        ...defaultResponse,
        '/api/careClientVisitor/init': careClientVisitorInitRes.error,
    },
    CARE_CLIENT_VISITOR_STATE_IS_END: {
        description: 'redirect to /transferInstruction page if the careClientVisitor state is END',
        ...defaultResponse,
        '/api/client/profile/get': profileGetRes.success.stateIsEnd,
    },
    CARE_CLIENT_VISITOR_HAS_MARKETING_CHANNEL_LIST: {
        description: 'the careClientVisitor has filled in marketingChannelList, so the marketingChannelList page should be skipped',
        ...defaultResponse,
        '/api/client/profile/get': profileGetRes.success.hasMarketingChannelList,
    },
    CARE_CLIENT_VISITOR_HAS_CONTRACT: {
        description: 'the careClientVisitor has signed the contract, so the contract page should be skipped',
        ...defaultResponse,
        '/api/client/profile/get': profileGetRes.success.hasContract,
    },
    CARE_CLIENT_VISITOR_HAS_MARKETING_CHANNEL_LIST_AND_CONTRACT: {
        description: 'the careClientVisitor has filled in marketingChannelList and signed the contract, so the marketingChannelList page and contract page should be skipped',
        ...defaultResponse,
        '/api/client/profile/get': profileGetRes.success.hasMarketingChannelListAndContract,
    },
    // error response of param/verify is handled in responseHandler.ts
    PARAM_VERIFY_ERROR_BAD_PARAMS_CONTACT_INFO_PAGE: {
        description: 'param verify failed with bad params',
        ...defaultResponse,
    },
    PARAM_VERIFY_ERROR_BAD_PARAMS_PATIENT_INFO_PAGE: {
        description: 'param verify failed with bad params',
        ...defaultResponse,
    },
    PARAM_VERIFY_ERROR_BAD_PARAMS_CARE_REQUIREMENT_PAGE: {
        description: 'param verify failed with bad params',
        ...defaultResponse,
    },
    CARE_ORDER_BABY_INIT_ERROR_BAD_PARAMS_TIME_SLOT_LIST: {
        description: 'init careOrderBaby failed with bad params timeSlotList',
        ...defaultResponse,
        '/api/client/careOrderBaby/init': careOrderBabyInitRes.error.badParamsTimeSlotList,
    },
    CARE_ORDER_BABY_INIT_ERROR_CARE_CLIENT_VISITOR_EXPIRED: {
        description: 'init careOrderBaby failed because the careClientVisitor is expired',
        ...defaultResponse,
        '/api/client/careOrderBaby/init': careOrderBabyInitRes.error.careClientVisitorExpired,
    },
    CARE_ORDER_BABY_INIT_ERROR_CARE_CLIENT_VISITOR_ALREADY_HAS_CARE_ORDER_BABY: {
        description: 'init careOrderBaby failed because the careClientVisitor already has careOrderBaby',
        ...defaultResponse,
        '/api/client/careOrderBaby/init': careOrderBabyInitRes.error.careClientVisitorAlreadyHasCareOrderBaby,
    },
};
export default mockScenarios;
